module.exports = __webpack_public_path__ + "static/media/headline.c1e47889.svg";